var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wysiwyg-editor',{staticClass:"col-12 p-0",attrs:{"id":_vm.question.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }